module.exports = __webpack_public_path__ + "img/kefub.4817c2d0.png";